import Message from './src/main.js';
export default Message;



// WEBPACK FOOTER //
// ./src/components/element/packages/message/index.js